export default __webpack_public_path__ + "static/media/BottleReacts.8c5b5cba.png";